import { Box } from '@mui/material';

import { changeIncludePublicAnswersForCo2 } from '@/domain/impact-calculate/actions/change-include-public-answers-for-co2.action';
import { selectIncludePublicAnswersForCo2 } from '@/domain/impact-calculate/impact-calculate.selectors';
import { Co2Section } from '@/domain/impact-co2/entities/question.entity';
import { selectImpactStatsPublic } from '@/domain/impact-stats/impact-stats.selectors';
import { useAppDispatch, useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';

import { IncludePublicAnswersForCo2Checkbox } from './components/IncludePublicAnswersForCo2Checkbox';
import { AccommodationData } from './components/public-answers/AccommodationData';
import { TransportData } from './components/public-answers/TransportData';
import { QuizFormSeparator } from './components/QuizFormSeparator';

export function Co2QuizPublicAnswers() {
  const dispatch = useAppDispatch();

  const statsPublic = useAppSelector(selectImpactStatsPublic);
  const includePublicAnswersForCo2 = useAppSelector(
    selectIncludePublicAnswersForCo2,
  );

  if (!statsPublic) {
    return null;
  }

  const onChangeIncludePublicAnswersForCo2 = async (checked: boolean) => {
    const params = { include: checked };
    dispatch(changeIncludePublicAnswersForCo2(params));
  };

  return (
    <Box>
      <IncludePublicAnswersForCo2Checkbox
        value={includePublicAnswersForCo2}
        onChange={onChangeIncludePublicAnswersForCo2}
      />
      <QuizFormSeparator
        label={translate(`Co2.Sections.${Co2Section.MOBILITY}`)}
      />
      <TransportData statsPublic={statsPublic} />
      <QuizFormSeparator
        label={translate(`Co2.Sections.${Co2Section.ACCOMMODATION}`)}
      />
      <AccommodationData statsPublic={statsPublic} />
    </Box>
  );
}
